import { RootState } from "../../applicationStore";
import { createSelector } from "@reduxjs/toolkit";
import { LOADING } from "../../../types";
import { HightlightState } from "../types/state";
import { TalesParagraph } from "../../../utils/types/TalesParagraph";

export const getHighlightState = (state: RootState): HightlightState =>
  state.highlight;

export const getHighlightData = createSelector(
  getHighlightState,
  (highlightState): TalesParagraph[] | null => highlightState?.data,
);

export const getHighlightError = createSelector(
  getHighlightState,
  (sponsorState): string | null => sponsorState?.error,
);

export const isHighlightLoading = createSelector(
  getHighlightState,
  (sponsorState): boolean => sponsorState?.loading === LOADING.PENDING ?? false,
);
